module.exports = __webpack_public_path__ + "img/privacy-02.af32a897.jpg";